

export default {
    name: 'bon-pdf-print',
    components: {},
    props: {
        print_data: {
            type: Object,
            default: () => ({})
        },
        data_toggler: Number
    },

    watch: {
        data_toggler() {
            console.log(">> ",this.print_data)
            if (this.print_data.data_type == 'bon_consultation') {
                this.printConsultation()
            } else {
                this.printData()
            }
            
        }
    },

    data() {
        return {
            can_print: false,
            can_print_consultation: false,
        }
    },

    computed: {

    },

    mounted() {

    },

    methods: {
        printData() {
            this.can_print = true
            setTimeout(() => {
                window.print()
                this.can_print = false
            }, 200);
        },

        printConsultation() {
            this.can_print_consultation = true
            setTimeout(() => {
                window.print()
                this.can_print_consultation = false
            }, 200);
        }
    }
}